import { type JSX, Show } from 'solid-js';
import { t, tPlural } from '../i18n';
import { Button, buttonClass } from './ui/Button';

// The two controls a 2,388-node timeline needs. Prod's longest run carries that
// many `<li>`s and the view offered no filter, no search and no collapse — so
// "what went wrong here" was a scroll.
//
// Presenter only: the predicate and the counting live in <FleetRunTimeline/>,
// which owns the events.

export type RunTimelineFiltersProps = {
  /** Heartbeats currently hidden. Zero renders no count, not "0 hidden". */
  readonly hiddenCount: number;
  readonly noiseHidden: boolean;
  readonly onToggleNoise: () => void;
  /** Anchor of the first failing node, or null when the run reported none. */
  readonly errorHref: string | null;
};

export function RunTimelineFilters(props: RunTimelineFiltersProps): JSX.Element {
  return (
    <fieldset class="filter-row">
      <legend class="sr-only">{t('fleet.filters_aria')}</legend>
      <Button
        variant="outline"
        size="sm"
        aria-pressed={props.noiseHidden}
        onClick={() => props.onToggleNoise()}
      >
        {props.noiseHidden ? t('fleet.show_noise') : t('fleet.hide_noise')}
      </Button>
      <Show when={props.noiseHidden && props.hiddenCount > 0}>
        <span class="timeline__meta">
          {tPlural('fleet.noise_hidden', props.hiddenCount, { count: props.hiddenCount })}
        </span>
      </Show>
      <Show when={props.errorHref}>
        {(href) => (
          <a class={buttonClass({ variant: 'outline', size: 'sm' })} href={href()}>
            {t('fleet.jump_to_error')}
          </a>
        )}
      </Show>
    </fieldset>
  );
}
